import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import ContactUs from './pages/ContactUs';
import DashDetail from './pages/DashDetail';
import SettingsDetail from './pages/SettingsDetail';
import AboutCompany from './pages/AboutCompany';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="productCenter" element={<Dashboard />} />
          {/* <Route path="settings" element={<Settings />} /> */}
          <Route path="contactUs" element={<ContactUs />} />
          <Route path="dashDetail/:id" element={<DashDetail />} />
          <Route path="settingsDetail/:id" element={<SettingsDetail />} />
          <Route path="aboutCompany" element={<AboutCompany />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
